import { useStaticQuery, graphql } from "gatsby";

export const useStrapiNavigationMenus = () => {
  const data = useStaticQuery(graphql`
    query GetNavigationMenus {
      strapi {
        navigationMenus {
          id
          label {
            ...LanguageText
          }
          link {
            ...LinkLocation
          }
          children {
            __typename
            ... on STRAPI_ComponentNavigationMenuReference {
              id
              menu {
                id
              }
            }
            ... on STRAPI_ComponentNavigationNavigationActionReference {
              id
              action {
                id                  
              }
            }
          }
        }
      }
  }`);

  return data.strapi.navigationMenus;
}